/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Nav_Sign_OutInputs */

const en_seller_nav_sign_out = /** @type {(inputs: Seller_Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign Out`)
};

const es_seller_nav_sign_out = /** @type {(inputs: Seller_Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar sesión`)
};

const fr_seller_nav_sign_out = /** @type {(inputs: Seller_Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se déconnecter`)
};

const de_seller_nav_sign_out = /** @type {(inputs: Seller_Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abmelden`)
};

const ja_seller_nav_sign_out = /** @type {(inputs: Seller_Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ログアウト`)
};

const zh_seller_nav_sign_out = /** @type {(inputs: Seller_Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`退出登录`)
};

const ar_seller_nav_sign_out = /** @type {(inputs: Seller_Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تسجيل الخروج`)
};

const id_seller_nav_sign_out = /** @type {(inputs: Seller_Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keluar`)
};

const it_seller_nav_sign_out = /** @type {(inputs: Seller_Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esci`)
};

const ru_seller_nav_sign_out = /** @type {(inputs: Seller_Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выйти`)
};

const pt_seller_nav_sign_out = /** @type {(inputs: Seller_Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sair`)
};

const ko_seller_nav_sign_out = /** @type {(inputs: Seller_Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로그아웃`)
};

/**
* | output |
* | --- |
* | "Sign Out" |
*
* @param {Seller_Nav_Sign_OutInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_nav_sign_out = /** @type {((inputs?: Seller_Nav_Sign_OutInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Nav_Sign_OutInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_nav_sign_out(inputs)
	if (locale === "es") return es_seller_nav_sign_out(inputs)
	if (locale === "fr") return fr_seller_nav_sign_out(inputs)
	if (locale === "de") return de_seller_nav_sign_out(inputs)
	if (locale === "ja") return ja_seller_nav_sign_out(inputs)
	if (locale === "zh") return zh_seller_nav_sign_out(inputs)
	if (locale === "ar") return ar_seller_nav_sign_out(inputs)
	if (locale === "id") return id_seller_nav_sign_out(inputs)
	if (locale === "it") return it_seller_nav_sign_out(inputs)
	if (locale === "ru") return ru_seller_nav_sign_out(inputs)
	if (locale === "pt") return pt_seller_nav_sign_out(inputs)
	return ko_seller_nav_sign_out(inputs)
});